"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var link = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 1000 1000", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("path", { fill: "currentColor", d: "M891 511c-96-96-188-130-281-90l115 116c28 8 56 27 84 55 72 72 82 140 9 213-72 72-141 63-213-10-31-31-51-63-57-94-36-35-92-91-111-110-44 95-10 189 87 286 130 129 253 147 383 17 130-131 113-254-16-383zM219 406c-72-72-81-141-9-213s141-63 213 9c30 30 49 60 56 89l114 113c42-94 8-187-89-283C375-9 251-26 121 104S8 358 138 487c96 96 189 130 283 89L308 462c-29-7-59-26-89-56zm502 155L452 293c-10-4-21-6-32-6-35 0-66 19-82 34-24 25-43 71-28 114l268 268c10 4 21 6 32 6 36 0 66-19 82-34 25-25 44-71 29-114z" })));
};
link.displayName = 'link';
exports.default = link;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=link.js.map